import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { PRIMARY_COURSE_ID } from '../course.constants';
import { normalizeCourseId } from '../course-id.aliases';
import { CourseContentService } from '../services/course-content.service';

export const courseAvailabilityGuard: CanActivateFn = async (
  route,
): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const content = inject(CourseContentService);
  const courseId = normalizeCourseId(route.paramMap.get('courseId'));

  await content.load(courseId);
  if (content.courseId() === courseId) {
    return true;
  }

  // Avoid a redirect loop if the public primary course is temporarily unavailable.
  return courseId === PRIMARY_COURSE_ID
    ? true
    : router.createUrlTree(['/kurse', PRIMARY_COURSE_ID, 'uebersicht']);
};
